import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'

export default function useGlobalActiveState (group, identifier) {
  const [isActive, setIsActive] = React.useState(false)
  const [activeId, setActiveId] = useEnvValue('globals.active_states.' + group, null)

  React.useEffect(() => {
    const currentIsActive = `${activeId}` === `${identifier}`

    if (currentIsActive !== isActive) {
      setIsActive(currentIsActive)
    }
  }, [activeId])

  function setAsActive (shouldBeActive = false) {
    if (shouldBeActive) {
      setActiveId(identifier)
    } else {
      setActiveId(null)
    }
  }

  return [isActive, setAsActive]
}
